import React, { useContext, useEffect } from 'react';
import { Tooltip, IconButton, Zoom } from '@mui/material';
import icons from './svgIcons'
import ClickAwayListener from '@mui/material/ClickAwayListener';
import './restrictionCopyMenu.scss'
import { RowDataContext } from './contexts';
import { copyRestrictionInRow, copyRestrictionInColum } from './functions';
import { useDispatch, useSelector } from 'react-redux';

function RestrictionCopyMenu(props) {
    const rowData = useContext(RowDataContext);
    const { openCopyBtn, data, bucketIndex, ratePlanIndex, roomTypeIndex, showCopyDown, showCopyRight, copiedRight, copiedDown, updateCompRef, markRestrictionsUpdate } = props;

    const { copyRight, copyDown, copyRightActive, copyDownActive } = icons;
    const [open, setOpen] = React.useState(openCopyBtn);
    const [visible, setVisible] = React.useState(openCopyBtn);
    const [copyRightIcon, setCopyRightIcon] = React.useState(copiedRight);
    const [copyDownIcon, setCopyDownIcon] = React.useState(copiedDown);
    const dispatch = useDispatch();

    const appState = useSelector((state) => state);
    const { app_state } = appState?.app?.current_state;

    const isLastItem = (type = 'row') => {
        try {
            let isLastCol = false;
            const size = rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex]?.rooms_summary.length;
            let indexOfRoomType = null;
            if (size) {
                indexOfRoomType = rowData.data.buckets[bucketIndex].rate_plans[ratePlanIndex]?.rooms_summary?.findIndex(itm => itm.room_type_code === data.room_type_code);
                isLastCol = size === indexOfRoomType + 1;
            }

            const isLastBucket = rowData.data.buckets.lenght === bucketIndex + 1;
            const isLastRatePlan = rowData.data.buckets[bucketIndex].rate_plans.length === ratePlanIndex + 1;

            if (type === 'col') return isLastCol;
            if (type === 'row') return isLastRatePlan;
        } catch (err) {
            console.error(err);
            return false;
        }
    }

    const isRatePlan = () => {
        return ratePlanIndex >= 0;
    }

    const handleClose = () => {
        setOpen(false); // trigger exit animation
        setTimeout(() => {
            setVisible(false); // unmount after exit finishes
            props.onCloseHandler();
        }, 300); // match exit timeout
    };

    const handleOpen = () => {
        //setOpen(true);
    };

    const handleCopyRight = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let copy = !data.copiedRight //|| !copyRightIcon;

        const roomTypeCode = data.room_type_code;
        const bi = bucketIndex;
        const rti = roomTypeIndex;
        const buckets = rowData.data.buckets;
        const restrictions = data.restrictions.user_override;
        const row = isRatePlan() ? buckets[bi].rate_plans[ratePlanIndex] : buckets[bi];
        // data.copied = copy;
        const newRow = copyRestrictionInRow(restrictions, row, rti, roomTypeCode, copy);

        setCopyRightIcon(copy);
        if (rowData.data.buckets[bi].rate_plans[ratePlanIndex].rooms_summary[rti]) {
            rowData.data.buckets[bi].rate_plans[ratePlanIndex].rooms_summary[rti].copiedRight = copy;
        }
        rowData.updateRowData(rowData.data);
        markRestrictionsUpdate();

        // if (app_state?.plrRowCalcStatus !== 'active') {

        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: {
        //             app_state: {
        //                 plrRowCalcStatus: 'active',
        //                 plrRecalcDate: rowData.data.date,
        //             }
        //         }
        //     });
        // }

    }

    const handleCopyDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let copy = !data.copiedDown //!copyDownIcon;
        setCopyDownIcon(copy);
        const roomTypeCode = data.room_type_code;
        const bi = bucketIndex;
        const rti = roomTypeIndex;
        const buckets = rowData.data.buckets;
        const restrictions = data.restrictions.user_override;
        const rows = isRatePlan() ? buckets[bi].rate_plans : buckets;
        const rowIndex = isRatePlan() ? ratePlanIndex : bucketIndex;

        const newRows = copyRestrictionInColum(restrictions, rows, rowIndex, rti, roomTypeCode, copy);
        if (rowData.data.buckets[bi].rate_plans[ratePlanIndex].rooms_summary[rti]) {
            rowData.data.buckets[bi].rate_plans[ratePlanIndex].rooms_summary[rti].copiedDown = copy;
        }
        rowData.updateRowData(rowData.data);
        markRestrictionsUpdate();

        // if (app_state?.plrRowCalcStatus !== 'active') {
        //     dispatch({
        //         type: "UPDATE_STATE",
        //         payload: {
        //             app_state: {
        //                 plrRowCalcStatus: 'active',
        //                 plrRecalcDate: rowData.data.date,
        //             }
        //         }
        //     });
        // }
    }
    let placement = isLastItem('col') ? 'bottom' : 'right';
    if (isLastItem('col') && isLastItem('row')) {
        placement = null;
    }
    useEffect(() => {
        setCopyRightIcon(data.copiedRight);
        setCopyDownIcon(data.copiedDown);

    }, []);
    return (
        // <Tooltip 
        //     arrow 
        //     open={open}  
        //     onOpen={handleOpen} 
        //     placement="right"
        //     className='restriction-copy-menu'
        //     classes={{
        //         tooltip: 'icon-btns-container',
        //     }}
        //     title={
        //         <ClickAwayListener onClickAway={handleClose}>
        //             <div className='icon-btns-group'>
        //                 <IconButton className='copy-btn' size='small' onClick={()=> handleCopyRight()}>{copyRightIcon ? copyRightActive : copyRight}</IconButton>
        //                 <IconButton className='copy-btn'  size='small' onClick={()=> handleCopyDown()} >{copyDownIcon ? copyDownActive : copyDown}</IconButton>
        //             </div>
        //         </ClickAwayListener>
        //     } 
        // />
        <>
            {visible && placement && (
                <Tooltip
                    arrow
                    open={open}
                    onOpen={handleOpen}
                    placement={placement}
                    className="restriction-copy-menu"
                    classes={{
                        tooltip: 'icon-btns-container',
                    }}
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: { enter: 300, exit: 300 } }}
                    PopperProps={{
                        keepMounted: true,
                    }}
                    title={
                        <ClickAwayListener onClickAway={handleClose}>
                            <div className='icon-btns-group'>
                                {showCopyRight && <IconButton className='copy-btn' size='small' onClick={(e) => handleCopyRight(e)}>{copyRightIcon ? copyRightActive : copyRight}</IconButton>}
                                {showCopyDown && <IconButton className='copy-btn' size='small' onClick={(e) => handleCopyDown(e)} >{copyDownIcon ? copyDownActive : copyDown}</IconButton>}
                            </div>
                        </ClickAwayListener>
                    }
                />
            )}
        </>
    )
}

export default RestrictionCopyMenu